import TYPES from './types';
import {promiseAction} from '~/misc/dispatch';
import * as api from './api'


export const getPrice = () => (dispatch, getState) => {
  return promiseAction(
    dispatch,
    getState,
    TYPES.FUELSURCHARGE_GET_PRICE,
    api.getPrice(getState)
  );
};




// WEBPACK FOOTER //
// ./src/pages/FuelSurchargePage/state/action.js